import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { WorkItemGenesysEmailListComponent } from './workitem-genesys-email-list.component';
import { WorkItemGenesysEmailListItemComponent } from './workitem-genesys-email-list-item/workitem-genesys-email-list-item.component';
import { WorkitemSimpleTimerModule } from 'shared/components/workitem-simple-timer/workitem-simple-timer.module';
import { FormatSecondsModule } from 'shared/pipes/format-seconds/format-seconds.pipe.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { WorkItemWidgetSharedModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/work-item-widget-shared.module';
import { GenesysProactiveEmailModalModule } from 'shared/components/genesys-proactive-email-modal/genesys-proactive-email-modal.module';
import { GenesysUserPermissionCheckModule } from 'shared/directives/genesys-user-permission-check';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgAvatarModule,
    SvgIconModule,
    WorkitemSimpleTimerModule,
    FormatSecondsModule,
    TooltipModule,
    WorkItemWidgetSharedModule,
    GenesysProactiveEmailModalModule,
    GenesysUserPermissionCheckModule,
    MatDialogModule
  ],
  declarations: [
    WorkItemGenesysEmailListComponent,
    WorkItemGenesysEmailListItemComponent
  ],
  exports: [
    WorkItemGenesysEmailListComponent
  ]
})
export class WorkItemGenesysEmailListModule { }
